import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import AbrdnButton from '@/components/Generic/Buttons/AbrdnButton';
import styles from './TertieryHeroBanner.module.scss';
import { ImageField, LinkField, TextField } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import Image from 'next/image';

type Fields = {
  title?: TextField;
  subtitle?: TextField;
  cta?: LinkField;
  icon?: ImageField;
};

type Props = Partial<ComponentProps> & {
  fields: Fields;
  anchorId?: string;
};

const TertieryHeroBanner: React.FC<Props> = ({ fields, rendering, anchorId }) => {
  const backgroundClass = rendering?.params?.background || 'background-digital-deep-grey';

  const isValueExists = (value: any): boolean => {
    return value !== undefined && value !== null;
  };

  return (
    <section
      id={anchorId}
      className={`${backgroundClass} ${styles.section} py-4 py-lg-7`}
      data-e2e-component-uid={rendering?.uid}
    >
      <div className="container w-100 pt-1 pt-md-5 pt-lg-6">
        <div className="row">
          <div className="col-12 col-md-8 col-lg-9">
            {fields.title && (
              <Text field={fields.title} tag="h1" className="background-to-change" />
            )}
            {fields.subtitle && (
              <Text
                field={fields.subtitle}
                tag="p"
                className={`body-large background-to-change mt-2 ${styles.subtitle}`}
              />
            )}
            {isValueExists(fields.cta) && (
              <AbrdnButton
                buttonType="textLink"
                className="mt-3 background-to-change"
                linkField={fields.cta}
              />
            )}
          </div>
          {fields.icon && (
            <div className="d-none d-md-flex col-md-4 col-lg-3 col-3 d-flex justify-content-end">
              <Image
                src={fields.icon?.value?.src || ''}
                alt={(fields.icon.value?.alt as string) || 'Icon'}
                className={`background-to-change ${styles.tertiaryHeroBannerImage}`}
                layout="responsive"
                width={100}
                height={100}
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default TertieryHeroBanner;
